// extracted by mini-css-extract-plugin
export var image = "_it-0";